import $ from 'jquery';
export default [
	function () {
		return {
			restrict: 'A',
			require: 'ngModel',
			scope: {
				target: '=ngModel',
				radioButtons: '=',
				name: '@',
				required: '=',
				layout: '@',
				isVisibilityToggle: '=',
				setDefaultInputValues: '&'
			},
			link: function (scope, elem, attr, ngModelCtrl) {
				var isValid = function () {
					return scope.required ? angular.isDefined(scope.target) : true;
				};

				scope.$watch('target', function () {
					$(elem).find('input:checked').parent().addClass('radio--active');
					$(elem).find('input:not(:checked)').parent().removeClass('radio--active');

					// többszintű feltételes radio button elágazás kezelése: ha változtatunk a főszinten, elfelejti az alszinten jelölt értéket
					var nextFieldset = $(elem).closest('fieldset').next();
					if (nextFieldset.attr('data-ng-if')) {
						var nextRadioButtonWithConditionName = nextFieldset.find('div[radio-buttons]').attr('name');
						if (nextRadioButtonWithConditionName) {
							var optionalRadioButtonParentFieldName = $(elem).closest('fieldset').find('div[radio-buttons]').attr('name');
							var isSelectedElementIsTheSameAsTheStoredToDelete = scope.$parent.optionalRadioButtonFieldsObject && scope.$parent.optionalRadioButtonFieldsObject.hasOwnProperty(optionalRadioButtonParentFieldName);
							if (isSelectedElementIsTheSameAsTheStoredToDelete) {
								delete scope.$parent.data[scope.$parent.currentStep][scope.$parent.optionalRadioButtonFieldsObject[optionalRadioButtonParentFieldName]];
								setTimeout(function () {
									scope.$apply();
								}, 0);
							}

							if (!scope.$parent.optionalRadioButtonFieldsObject) {
								scope.$parent.optionalRadioButtonFieldsObject = {};
								scope.$parent.optionalRadioButtonFieldsObject[optionalRadioButtonParentFieldName] = nextRadioButtonWithConditionName;
							} else if (!scope.$parent.optionalRadioButtonFieldsObject.hasOwnProperty(optionalRadioButtonParentFieldName) || (scope.$parent.optionalRadioButtonFieldsObject.hasOwnProperty(optionalRadioButtonParentFieldName) && scope.$parent.optionalRadioButtonFieldsObject[optionalRadioButtonParentFieldName] != nextRadioButtonWithConditionName)) {
								scope.$parent.optionalRadioButtonFieldsObject[optionalRadioButtonParentFieldName] = nextRadioButtonWithConditionName;
							}
						}
					}

					var valid = isValid();
					ngModelCtrl.$setValidity('required', valid);
				});
			},
			template: function (tElem, tAttrs) {
				var inputFragment = '<input type="radio" name="{{name+\'_inner\'}}" data-ng-model="$parent.$parent.target" value="{{radio.value}}" >';

				if (tAttrs.isVisibilityToggle) {
					inputFragment = '<input type="radio" name="{{name+\'_inner\'}}" data-ng-model="$parent.$parent.target" value="{{radio.value}}" data-ng-change="setDefaultInputValues()">';
				}

				var ret = '<div data-ng-if="layout===\'grid\'" class="radio-group">' + '<div data-ng-repeat="radio in radioButtons" class="radio-group__item">' + '<label class="radio" >' + inputFragment + '<span class="radio__box"></span>' + '{{radio.label}}' + '</label>' + '</div>' + '</div>' + '<label data-ng-if="layout!==\'grid\'" data-ng-repeat="radio in radioButtons" class="radio">' + inputFragment + '<span class="radio__box"></span>' + '{{radio.label}}' + '</label>';

				return ret;
			}
		};
	}
];
